<i18n src='@/locale/organization-localization.json'></i18n>

<template>
  <v-autocomplete
    v-model="select"
    @input="handleInput"
    :items="items"
    :search-input.sync="search"
    :item-text="displayName"
    :label="label || $t('Title')"
    return-object
    dense
    outlined
    clearable
    no-filter
    flat
    hide-no-data
    hide-details
  ></v-autocomplete>
</template>

<script>
import OrganizationService from '@/service/organization-service';

export default {
  props: {
    value: Number,
    label: String,
    parentCode: Number,
    parentPharmacy: Boolean,
    parentBranch: Boolean,
    parentInsurance: Boolean,
    parentTwoLevel: Boolean,
    preload: Boolean,
    hasPaymentInAdvance: Boolean
  },
  data() {
    return {
      preloadItems: [],
      items: [],
      search: null,
      select: null,
      timer: null,
      getDataAbort: null,
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    search(value, oldValue) {
      if (value !== oldValue) {
        if (
          value !== (this.select ? this.select.code : null) &&
          value !== this.displayName(this.select)
        ) {
          clearTimeout(this.timer);
          this.items = [];
          if (this.getDataAbort) {
            this.getDataAbort.abort();
          }
          if (value) {
            this.timer = setTimeout(() => this.querySelections(value), 300);
          } else if (this.preload) {
            this.items = this.preloadItems;
          }
        }
      }
    },
    value(val) {
      if (!val) {
        this.search = null;
        this.select = null;
        this.items = [];
      } else {
        this.setSelected(val);
      }
    },
    parentCode() {
      this.loadData();
    },
    parentPharmacy() {
      this.loadData();
    },
    parentBranch() {
      this.loadData();
    },
    parentInsurance() {
      this.loadData();
    },
    parentTwoLevel() {
      this.loadData();
    },
    preload() {
      this.loadData();
    }
  },
  methods: {
    async getData(filter, loadAll) {
      if (this.getDataAbort) {
        this.getDataAbort.abort();
        this.items = [];
      }
      this.getDataAbort = new AbortController();
      const parentCode = this.parentPharmacy
        ? await OrganizationService.constant.parentCode.pharmacy()
        : this.parentBranch
        ? await OrganizationService.constant.parentCode.branch()
        : this.parentInsurance
        ? await OrganizationService.constant.parentCode.insurance()
        : this.parentCode;
      let localFilter = Object.assign({}, filter);
      localFilter.has_payment_in_advance = this.hasPaymentInAdvance;
      if (this.parentTwoLevel) {
        localFilter.parent_code_two_level = localFilter.parent_code;
      } else {
        localFilter.parent_code = parentCode || this.parentCode;
      }
      let signal = this.getDataAbort ? this.getDataAbort.signal : null;
      return OrganizationService.getData(1, loadAll ? 0 : 20, localFilter, signal)
        .finally(() => this.getDataAbort = null);
    },
    loadData() {
      this.preloadItems = [];
      this.items = [];
      if (this.preload) {
        return this.getData(null, true)
          .then(resp => {
            this.preloadItems = resp.data;
            this.items = this.preloadItems;
            if (this.search) {
              return this.querySelections(this.search);
            }
            if (this.value) {
              return this.setSelected(this.value);
            }
            return Promise.resolve();
          });
      } else if (this.search) {
        return this.querySelections(this.search)
          .then(() => {
            if (this.value) {
              return this.setSelected(this.value);
            }
            return Promise.resolve();
          });
      } else if (this.value) {
        return this.setSelected(this.value);
      }
      return Promise.reject();
    },
    querySelections(search) {
      if (this.preload) {
        this.items = search
          ? this.preloadItems.filter(i => i.code.toString() == search || i.name.indexOf(search) > 0)
          : this.preloadItems;
        return Promise.resolve();
      } else {
        return this.getData({ search }).then(resp => this.items = resp.data);
      }
    },
    handleInput() {
      this.$emit("input", this.select ? this.select.code : null);
    },
    setSelected(value) {
      if (this.preload) {
        if (value) {
          let filtered = this.items.filter(i => i.code == value);
          this.select = filtered.length > 0 ? filtered[0] : null;
          if (this.select) {
            return Promise.resolve();
          }
        } else {
          this.select = null;
        }
      } else if (value && value !== (this.select ? this.select.code : null)) {
        return this.getData({ code: value }).then(resp => {
          var data = resp.data.filter((d) => d.code == value);
          if (data.length == 0) {
            return Promise.reject();
          }
          this.items = data;
          this.select = data[0];
          return Promise.resolve();
        });
      }
      return Promise.reject();
    },
    displayName(item) {
      if (item) {
        return `[${item.code}] ${item.name || ""}`;
      }
      return null;
    },
  },
};
</script>

<style>
</style>